// Module
var code = " <md-input-container> <label translate=\"TEXT_WIDGET_TEXT_LABEL\"></label> <input ng-model=\"$ctrl.getWidget().text\" ng-change=\"$ctrl.gbEditTools.saveWidget()\" ng-disabled=\"!$ctrl.getWidget()\"/> </md-input-container> <gb-edit-base-widget widget=\"$ctrl.getWidget()\"></gb-edit-base-widget> ";
// Exports
export default code;